import "./page.css";
import Card from "../card/Card";
export function Page({ children }: { children: React.ReactNode }) {
  return <div className="page">{children}</div>;
}

export function PageHeader({ title, children }: { title: string; children?: React.ReactNode }) {
  return (
    <div className="page-header">
      <h1>{title}</h1>
      {children}
    </div>
  );
}

export function FilterBar({ children }: { children: React.ReactNode }) {
  return (
    <div className="page-filter">
      <Card>
        <div className="filter-body">{children}</div>
      </Card>
    </div>
  );
}

export function PageBody({ children }: { children: React.ReactNode }) {
  return <div className="page-body">{children}</div>;
}
